import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=485329c4&scoped=true&"
import script from "./TextField.vue?vue&type=script&lang=js&"
export * from "./TextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485329c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485329c4')) {
      api.createRecord('485329c4', component.options)
    } else {
      api.reload('485329c4', component.options)
    }
    module.hot.accept("./TextField.vue?vue&type=template&id=485329c4&scoped=true&", function () {
      api.rerender('485329c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/form/TextField.vue"
export default component.exports